<template>
<div class="container">
<b-row >
<b-container v-if="this.$route.name == 'proveedores'">
	<h4>
	<label v-if="listPaises.length!=0" >País</label>
	<select  v-if="listPaises.length!=0" v-model="pais" @click="f_muestra_proveedor()">
		<option
			v-for="(item, idx) in listPaises"
			:key="idx"
			:value="item.pais">
			{{item.pais}}
		</option>
	</select>
	</h4>
	<md-table v-model="listProveedores" md-card md-fixed-header @md-selected="f_muestra">
	<md-table-toolbar>
		<h1 class="md-title"><b><i>{{f_titulo()}}</i></b></h1>
	</md-table-toolbar>
	<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
		<md-table-cell :md-label="labels.identificacion" class="text-left border">{{item.identificacion}}</md-table-cell>
		<md-table-cell :md-label="labels.proveedor" class="text-left border">{{item.nombre}}</md-table-cell>
		<md-table-cell :md-label="labels.usuario" class="text-left border">{{f_nombre_usuario(item.id_usuario)}}</md-table-cell>
		<md-table-cell :md-label="labels.facturas" class="text-left border">{{item.facturas}}</md-table-cell>
		<md-table-cell :md-label="labels.items" class="text-left border">{{item.items}}</md-table-cell>
	</md-table-row>
	</md-table>
</b-container>
<b-container v-if="this.$route.name == 'proveedoranalista'">
	<h4>
	<label v-if="listPaises.length!=0" >País</label>
	<select  v-if="listPaises.length!=0" v-model="pais" @click="f_muestra_proveedor()">
		<option
			v-for="(item, idx) in listPaises"
			:key="idx"
			:value="item.pais">
			{{item.pais}}
		</option>
	</select>
	</h4>
	<md-table v-model="listProveedores" md-card md-fixed-header @md-selected="f_cambia_analista">
	<md-table-toolbar>
		<h1 class="md-title"><b><i>{{f_titulo()}}</i></b></h1>
	</md-table-toolbar>
	<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="multiple">
		<md-table-cell :md-label="labels.identificacion" class="text-left border">{{item.identificacion}}</md-table-cell>
		<md-table-cell :md-label="labels.proveedor" class="text-left border">{{item.nombre}}</md-table-cell>
		<md-table-cell :md-label="labels.usuario" class="text-left border">{{f_nombre_usuario(item.id_usuario)}}</md-table-cell>
		<md-table-cell :md-label="labels.facturas" class="text-left border">{{item.facturas}}</md-table-cell>
		<md-table-cell :md-label="labels.items" class="text-left border">{{item.items}}</md-table-cell>
	</md-table-row>
	</md-table>
	<md-table>
	<md-table-row class="text-center">
		<h4>
		<label v-if="listPaises.length!=0 && listCambiaAnalista.length!=0">Analista</label>
		<select v-if="listPaises.length!=0 && listCambiaAnalista.length!=0" v-model="nuevoAnalista" >
			<option
				v-for="(item, idx) in listLiderUsuarios"
				:key="'id_usuario-'+idx"
				:value="item.id_usuario">
				{{item.name}}
			</option>
		</select>&nbsp;&nbsp;&nbsp;&nbsp;
		<md-button v-if="listCambiaAnalista.length>0 && nuevoAnalista>0" class="md-primary md-raised" @click="f_graba_cambio_analista()">Cambia Analista</md-button>
		</h4>
	</md-table-row>
	</md-table>
</b-container>
<md-dialog :md-active.sync="fgl_muestraFacturas">
	<md-dialog-title class="text-center">
		<h3><b><i>
			{{f_titulo_facturas()}}<br>
			{{f_titulo_cambio()}}
		</i></b><br> </h3>
	</md-dialog-title>
	<md-dialog-content>
		<md-table>
		<md-table-row class="text-center">
		<md-button class="md-primary md-raised"><h3><b><i>Cambio:</i></b></h3></md-button>&nbsp;&nbsp;&nbsp;&nbsp;
		<md-button class="md-primary md-raised" @click="f_cambia_pedido(1)"><h3><b><i>Identificacion</i></b></h3></md-button>&nbsp;&nbsp;&nbsp;&nbsp;
		<md-button class="md-primary md-raised" @click="f_cambia_pedido(2)"><h3><b><i>Nombre</i></b></h3></md-button>&nbsp;&nbsp;&nbsp;&nbsp;
		<md-button class="md-primary md-raised" @click="f_cambia_pedido(3)"><h3><b><i>Pedido</i></b></h3></md-button>&nbsp;&nbsp;&nbsp;&nbsp;
	<md-button class="md-primary md-raised" @click="f_cambia_pedido(4)"><h3><b><i>Informacion</i></b></h3></md-button>
		</md-table-row>
		</md-table>
		<md-table v-if="fgl_cambia_global" v-model="listFacturasProveedor" md-card md-fixed-header @md-selected="f_cambia_varias">
			<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="multiple">
				<md-table-cell :md-label="labels.fecha" class="text-left border">{{item.fecha_factura}}</md-table-cell>
				<md-table-cell :md-label="labels.documento" class="text-left border">{{item.documento}}</md-table-cell>
				<md-table-cell :md-label="labels.factura" class="text-left border">{{item.factura}}</md-table-cell>
				<md-table-cell :md-label="labels.identificacion" class="text-left border">{{item.identificacion}}</md-table-cell>
				<md-table-cell :md-label="labels.proveedor" class="text-left border">{{item.nombre}}</md-table-cell>
				<md-table-cell :md-label="labels.pedido" class="text-left border">{{item.pedido}}</md-table-cell>
				<md-table-cell :md-label="labels.identificacion_pedido" class="text-left border">{{f_identificacion_pedido(item.identificacion,item.pedido,item.factura,item.nombre,item.fecha_factura)}}</md-table-cell>
				<md-table-cell :md-label="labels.proveedor_pedido" class="text-left border">{{f_nombre_pedido(item.pedido,item.identificacion,item.factura,item.nombre,item.fecha_factura)}}</md-table-cell>
			</md-table-row>
		</md-table>
		<md-table v-if="!fgl_cambia_global" v-model="listFacturasProveedor" md-card md-fixed-header >
			<md-table-row slot="md-table-row" slot-scope="{ item }" >
				<md-table-cell :md-label="labels.fecha" class="text-left border">{{item.fecha_factura}}</md-table-cell>
				<md-table-cell :md-label="labels.documento" class="text-left border">{{item.documento}}</md-table-cell>
				<md-table-cell :md-label="labels.factura" class="text-left border">{{item.factura}}</md-table-cell>
				<md-table-cell :md-label="labels.identificacion" class="text-left border">{{item.identificacion}}</md-table-cell>
				<md-table-cell :md-label="labels.proveedor" class="text-left border">{{item.nombre}}</md-table-cell>
				<md-table-cell :md-label="labels.pedido" class="text-left border">{{item.pedido}}</md-table-cell>
				<md-table-cell v-if="fgl_cambia_nombre" :md-label="labels.proveedor_nuevo" class="text-left border"><input v-model="item.nombre_nuevo"  @input="f_completar()"></md-table-cell>
				<md-table-cell v-if="fgl_cambia_identificacion" :md-label="labels.identificacion_nueva" class="text-left border"><input v-model="item.identificacion_nueva" @input="f_completar()"></md-table-cell>
				<md-table-cell v-if="fgl_cambia_pedido" :md-label="labels.pedido_nuevo" class="text-left border"><input v-model="item.pedido_nuevo" @input="f_completar()"></md-table-cell>
			</md-table-row>
		</md-table>
		<md-table>
		<md-table-row class="text-center">
			<md-button v-if="listCambiaFacturas.length>0 && fgl_grabar" class="md-primary md-raised" @click="f_grabar()">Grabar</md-button>&nbsp;&nbsp;&nbsp;&nbsp;
			<md-button class="md-primary md-raised" @click="fgl_muestraFacturas=false">Cerrar</md-button>
		</md-table-row>
		</md-table>
	</md-dialog-content>
</md-dialog>
<md-dialog :md-active.sync="fgl_cambia_proveedor">
	<md-dialog-title class="text-center">
		<h3><b><i> {{f_titulo()}} </i></b></h3>
	</md-dialog-title>
	<md-dialog-content>
		<md-table-row class="text-center">
			<md-table-cell :md-label="labels.identificacion" class="text-left border">{{proveedor.identificacion}}</md-table-cell>
			<md-table-cell :md-label="labels.proveedor" class="text-left border">{{proveedor.nombre}}</md-table-cell>
		</md-table-row>
		<md-table-row class="text-center">
			<md-button v-if="listCambiaFacturas.length>0 && fgl_grabar" class="md-primary md-raised" @click="f_grabar_cambio_proveedor()">Grabar</md-button>&nbsp;&nbsp;&nbsp;&nbsp;
			<md-button class="md-primary md-raised" @click="fgl_cambiaProveedor=false">Cerrar</md-button>
		</md-table-row>
	</md-dialog-content>
</md-dialog>
</b-row>
</div>
</template>
<script>
import Factura from "@/services/Facturas"
import User from "@/services/User"
import Lider from "@/services/Lideres"

export default {
name:'Proveedores',
data: () => ({
	factura: '',
	pais: '',
	identificacion: '',
	usuario: '',
	nuevoAnalista: '',
	titulo_factura: "",
	users : [],
	listPaises : [],
	listProveedores : [],
	listLiderUsuarios : [],
	listFacturasProveedor : [],
	listFacturaControl : [],
	listProveedor : [],
	listOrdenCompra : [],
	fgl_muestraFacturas : false,
	proveedor:{},
	listCambiaFacturas: [],
	listCambiaAnalista: [],
	cambiaInformacion: [],
	fgl_cambia_informacion: false,
	fgl_cambia_nombre: false,
	fgl_cambia_identificacion: false,
	fgl_cambia_pedido: false,
	fgl_cambia_global: false,
	fgl_cambia_proveedor: false,
	fgl_grabar: false,
}),
computed:{
labels(){
	if (this.$store.state._language == "es-ES") {
		return {
			title : "FACTURAS",
			documento : "Tipo",
			factura : "Factura",
			facturas : "Facturas",
			fecha : "Fecha",
			identificacion : "Identificación",
			identificacion_nueva : "Identificación Nueva",
			identificacion_pedido : "Id(Nuevo)",
			proveedor : "Nombre",
			proveedor_nuevo : "Nombre Nuevo",
			proveedor_pedido : "Nombre(Nuevo)",
			pedido : "Pedido",
			pedido_nuevo : "Pedido Nuevo",
			valor : "Valor Bruto",
			impuesto0 : "Impuesto0",
			categoria0 : "Categoria0",
			impuesto1 : "Impuesto1",
			categoria1 : "Categoria1",
			impuesto2 : "Impuesto2",
			categoria2 : "Categoria2",
			impuesto : "Total Impuesto",
			valor_total : "Total Factura",
			items : "Items",
			usuario : "Usuario",
		}
	}else{
		return {
			title : "INVOICES",
			factura : "Invoice",
			fecha : "Date",
			identificacion : "Identification",
			proveedor : "Name",
			cantidad : "Invoices",
			pedido : "Order",
			valor : "Amount",
			impuesto0 : "Tax0",
			categoria0 : "Category0",
			impuesto1 : "Tax1",
			categoria1 : "Category1",
			impuesto2 : "Tax2",
			categoria2 : "Category2",
			impuesto : "Taxes",
			valor_total : "Total Amount",
			items : "Items",
			item : "Item",
			descripcion : "Description",
			diferencia_precio : "Price Dif",
			diferencia_cantidad : "Amount Dif",
			diferencia_iva : "Iva Dif",
			diferencia_impuesto : "Other Tax Dif",
			diferencia_Total : "Total",
			diferencia_total : "Total Dif",
			valor_fe : "FE Value",
			valor_sap : "SAP Value",
		}
	}
}
},
mounted(){
	Factura.leaPaises()
	.then((res) => {
		this.listPaises = res.data.listPaises
	})
	.catch((err) => {
		console.log(err)
	})
	User.getAllUsers(this.$store.state.userName)
	.then((result) => {
		this.users = result.data.users;
	})
	.catch((err) => {
		console.log(err)
	})
	Lider.leaLiderUsuarios(this.$store.state.userId)
	.then((res) => {
		this.listLiderUsuarios= res.data.listLiderUsuarios
	})
	.catch((err) => {
		console.log(err)
	})
},
methods:{
	f_titulo() {
		if      (this.$route.name == "proveedores") {
			return "MANTENIMIENTO DE PROVEEDORES"
		}

		if      (this.$route.name == "proveedoranalista") {
			return "REASIGNACION DE ANALISTAS"
		}
		return "SIN TITULO "+this.$route.name
	},
	f_titulo_facturas() {
		return "MANTENIMIENTO DE FACTURAS DE "+this.proveedor.nombre+
			"(ID="+this.proveedor.identificacion+")"
	},
	f_titulo_cambio() {
		if	(this.fgl_cambia_identificacion) {
			return "CAMBIO DE IDENTIFICACION"
		}
		if	(this.fgl_cambia_nombre) {
			return "CAMBIO DE NOMBRE"
		}
		if	(this.fgl_cambia_pedido) {
			return "CAMBIO DE PEDIDO"
		}
		if	(this.fgl_cambia_global) {
			return "CAMBIO IDENTIFICACION & NOMBRE A PARTIR DE LA INFORMACION"
		}
	},
	f_muestra_proveedor() {
		let opcion = 0
		if      (this.$route.name == "proveedoranalista") {
			opcion = 1
		}
		Factura.leaProveedores(this.pais,opcion)
		.then((res) => {
			this.listProveedores = res.data.listProveedores
		})
		.catch((err) => {
			console.log(err)
		})
	},
	f_muestra(r_proveedor) {
		this.proveedor = r_proveedor
		this.fgl_muestraFacturas=false
		this.fgl_cambia_identificacion=false;
		this.fgl_cambia_nombre=false;
		this.fgl_cambia_pedido=false;
		this.listCambiaFacturas = []
		Factura.leaFacturasProveedor(this.pais,r_proveedor.identificacion,r_proveedor.nombre)
		.then((res) => {
			this.listFacturasProveedor = res.data.listFacturasProveedor
			this.listOrdenCompra = res.data.listOrdenCompra
			this.listFacturaControl = res.data.listFacturaControl
			this.listProveedor = res.data.listProveedor
			if	(this.listFacturasProveedor.length > 0 ) {
				this.fgl_muestraFacturas=true
			}
		})
		.catch((err) => {
			console.log(err)
		})
	},
	f_cambia_analista(r_proveedores) {
		this.listCambiaAnalista = r_proveedores
	},
	f_graba_cambio_analista() {
		Factura.grabaCambioAnalista(this.pais,this.listCambiaAnalista,this.nuevoAnalista,this.$store.state.userId)
		.then(() => {
			this.$toast.success("Cambio de Analista Correcto")
		})
		.catch(() => {
			this.$toast.error("Problema al cambiar Analista")
		})
		this.listCambiaAnalista=[]
		this.nuevoAnalista=''
		this.listProveedores=[]
		setTimeout(() => { this.f_muestra_proveedor() },1000)
	},
	f_muestra_cambio(r_proveedor) {
		this.proveedor = r_proveedor
		this.fgl_muestraFacturas=false
		this.fgl_cambia_identificacion=false;
		this.fgl_cambia_nombre=false;
		this.fgl_cambia_pedido=false;
		this.fgl_cambia_proveedor=true;
	},
	f_nombre_usuario(id) {
		if	(id === undefined || id === null) {
			return "No Definido"
		}
		const usuario = this.users.find((usuario) => usuario.id == id)
		if	(usuario == undefined) {
			return "SIN Informacion en BD "+id
		}
		return usuario.name
	},
	f_nombre_pedido(pedido,identificacion,factura,nombre,fecha) {
		if	(this.listProveedor.length>0) {
			const v_nombre = this.listProveedor[0].nombre
			return v_nombre
		}
		if	(this.listFacturaControl.length > 0) {
			const v_nombre = this.f_nombre_control(identificacion,factura,nombre,fecha)
			return v_nombre
		} 
		const v_pedido = this.listOrdenCompra.find((orden) => orden.orden_compra == pedido)
		if	(v_pedido == undefined) {
			return "No Definido"
		} else {
			let v_nombre = v_pedido.nombre_proveedor
			const v_idx = v_nombre.indexOf(' ')+1
			v_nombre=v_nombre.substring(v_idx)
			return v_nombre
		}
	},
	f_nombre_control(identificacion,factura,nombre,fecha) {
		let v_nombre=nombre
		if	(this.listFacturaControl.length > 0) {
			let v_factura_control=this.listFacturaControl.find(
				(control) => control.factura == factura &&
				control.fecha == fecha)
			if	(v_factura_control == undefined && identificacion.length>0) {
				v_factura_control=this.listFacturaControl.find(
					(control) => control.identificacion == identificacion)
			}
			if	(v_factura_control != undefined) {
				v_nombre = v_factura_control.razon_social
			}
		}
		return v_nombre
	},
	f_identificacion_pedido(identificacion,pedido,factura,nombre,fecha) {
		if	(this.listFacturaControl.length > 0) {
			const v_identificacion = this.f_identificacion_control(identificacion,factura,nombre,fecha)
			return v_identificacion
		}
		if	(identificacion != '') {
			return identificacion
		}
		const v_pedido = this.listOrdenCompra.find((orden) => orden.orden_compra == pedido)
		if	(v_pedido == undefined) {
			return identificacion
		} else {
			const v_nombre = v_pedido.nombre_proveedor
			const v_idx = v_nombre.indexOf(' ')
			let v_identificacion="A"+v_nombre.substring(0,v_idx)
			return v_identificacion
		}
		
	},
	f_identificacion_control(identificacion,factura,nombre,fecha) {
		let v_pedido = this.listFacturaControl.find((control) => control.factura == factura &&
				control.fecha == fecha)
		if	(v_pedido == undefined) {
			v_pedido = this.listFacturaControl.find((control) => control.razon_social == nombre)
		}
		if	(v_pedido == undefined) {
			return identificacion
		} else {
			const v_identificacion = v_pedido.identificacion
			return v_identificacion
		}
		
	},
	f_cambia_varias(r_facturas) {
		r_facturas.forEach((factura) => {
			const v_nombre = this.f_nombre_pedido(factura.pedido,factura.identificacion,factura.factura,factura.nombre,factura.fecha_factura)
			let v_identificacion=factura.identificacion
			if	(factura.identificacion == '') {
				v_identificacion = this.f_identificacion_pedido(
					factura.identificacion,factura.pedido,factura.factura,factura.nombre,factura.fecha_factura)
			}
			factura.cambia=false
			if	(v_nombre != "No Definido") {
				factura.nombre_nuevo=v_nombre.trimStart()
				factura.identificacion_nueva=v_identificacion
				factura.cambia=true
			}
		})
		this.listCambiaFacturas = r_facturas
	},
	f_cambia_varias_1() {
		this.listCambiaFacturas=[]
		this.listFacturasProveedor.forEach((factura,idx) => {
			const v_nombre = this.f_nombre_pedido(factura.pedido,factura.identificacion,factura.factura,factura.nombre,factura.fecha_factura)
			let v_identificacion=factura.identificacion
			if	(factura.identificacion == '') {
				v_identificacion = this.f_identificacion_pedido(
					factura.identificacion,factura.pedido,factura.factura,factura.nombre,factura.fecha_factura)
			}
			this.listFacturasProveedor[idx].cambia=false
			if	(v_nombre != "No Definido") {
				this.listFacturasProveedor[idx].nombre_nuevo=v_nombre.trimStart()
				this.listFacturasProveedor[idx].identificacion_nueva=v_identificacion
				this.listFacturasProveedor[idx].cambia=true
				this.listCambiaFacturas.push(this.listFacturasProveedor[idx])
			}
		})
	},
	f_grabar() {
		Factura.grabaFacturasProveedor(this.listCambiaFacturas)
		.then(() => {
			this.$toast.success("Cambio de proveedor Correcto")
		})
		.catch(() => {
			this.$toast.error("Problema al cambiar el Proveedor")
		})
		this.fgl_muestraFacturas=false
	},
	f_cambia_pedido(opcion)  {
		this.fgl_cambia_pedido=false
		this.fgl_cambia_identificacion=false
		this.fgl_cambia_nombre=false
		this.fgl_cambia_global=false
		this.fgl_grabar=false
		if	(opcion == 1) {
			this.fgl_cambia_identificacion=true
		}
		if	(opcion == 2) {
			this.fgl_cambia_nombre=true
		}
		if	(opcion == 3) {
			this.fgl_cambia_pedido=true
		}
		if	(opcion == 4) {
			this.fgl_cambia_global=true
			this.f_cambia_varias_1()
		}
		this.fgl_grabar=true
	},
	f_completar() {
		this.listCambiaFacturas=[]
		this.listFacturasProveedor.forEach((factura) => {
			factura.cambia = false
			if	(factura.nombre_nuevo !== undefined) {
				if	(factura.nombre_nuevo.length>0) {
					factura.cambia=true
				}
			}
			if	(factura.identificacion_nueva !== undefined) {
				if	(factura.identificacion_nueva.length>0) {
					factura.cambia=true
				}
			}
			if	(factura.pedido_nuevo !== undefined) {
				if	(factura.pedido_nuevo.length>0) {
					factura.cambia=true
				}
			}
			if	(factura.cambia == true) {
				this.listCambiaFacturas.push(factura)
			}
		})
	},
}

}
</script>

<style>
table {
	table-layout:fixed;
}
.md-table-fixed-header-active {
	border-bottom: 20px solid;
}

</style>
